import { render, staticRenderFns } from "./TrasladoDescarte.vue?vue&type=template&id=75bef13a"
import script from "./TrasladoDescarte.vue?vue&type=script&lang=js"
export * from "./TrasladoDescarte.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports